import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {withSidePanel} from '../../../SidePanel';
import {injectIntl} from 'react-intl';
import {StyledButton, DispatchIcon, StyledDiv} from './styles';
import messages from './messages';
import CreateDispatchPanel from 'components/CreateDispatchPanel';
import dispatchMessages from '../../../CreateDispatchPanel/messages';

@withSidePanel
@injectIntl
@inject('store')
@observer
class DispatchButton extends Component {
  onDispatchButtonClick = () => {
    this.props.pushSidePanel({
      title: this.props.intl.formatMessage(dispatchMessages.createDispatchTitle),
      content: <CreateDispatchPanel />
    });
  };

  render() {
    const {
      store,
      stepIndex,
      intl: {formatMessage},
      isMobile
    } = this.props;
    const {instructionPage, checklist} = store;
    const {currentInstruction} = instructionPage;
    const {checklist: newChecklist} = checklist;

    const currentStepId = currentInstruction.steps[stepIndex].id;
    const currentStep = newChecklist[currentStepId];
    const checkEscalated = currentStep?.checkEscalated;

    return (
      <StyledButton
        onClick={!checkEscalated ? this.onDispatchButtonClick : undefined}
        checkEscalated={checkEscalated}
        aria-label="dispatch"
        isMobile={isMobile}
      >
        <DispatchIcon isMobile={isMobile} />
        <StyledDiv isMobile={isMobile}>
          {checkEscalated ? formatMessage(messages.dispatchSent) : formatMessage(messages.createDispatch)}
        </StyledDiv>
      </StyledButton>
    );
  }
}

export default DispatchButton;
